export class HagertySupportingData {
  lossTimestamp: string;
  vehicleId: string;

  constructor() {
      this.lossTimestamp = '';
      this.vehicleId = '';
  }
}
